<template>
  <div class="selectmenu">
    <div class="selectTitle">已选菜单</div>
    <div class="selectMain">
      <div v-if="tableList.length==0" class="hiddenTips">
        <div class="tips">
          <img src="../../../assets/imgs/left.png" alt="" style="width:200px;height:200px" />
          <span>点击左侧菜品，开始点餐</span>
        </div>
      </div>
      <div class="selectItem" v-for="(v,i) in tableList" :key="i">
        <div class="selectTop">

          <span>{{v.dishesCode}}</span>
          <span style="color: #666; font-size: 16px" @click="updatename(v,i)">{{v.dishesName}}<i class="el-icon-edit"
              style="cursor:pointer" v-if="v.is_can_update_name"></i> </span>

          <span style="color: #fe852f;" @click="updatequantity(v,i)">￥{{v.price.toFixed(2)}}/{{v.unitName}} <i
              class="el-icon-edit" style="cursor:pointer" v-if="v.is_can_update_price"></i></span>

          <div @click="openJSvalue(v)">
            技师:{{v.JSvalue}}

            <!-- <el-select v-model="v.JSvalue" @change="updateModel(v,i)">
              <el-option v-for="(item,n) in options" :key="n" :label="item.description" :value="item.id">
              </el-option>
            </el-select> -->
          </div>
          <div>
            要求:
            <input type="text" v-model="v.remark" v-if=" v.remark" @focus="requirementValueBlur(v)"
              style="width:130px;border:0;border-bottom:1px solid #eaeaea;outline:none">
            <i class="el-icon-edit" @click="requirementValueBlur(v)" style="cursor:pointer"></i>
          </div>
          <div class="selectNum">
            <div class="reduce" @click="reduceNum(v,i)">
              <img src="../../../assets/imgs/reduce.png" width="22px" height="22px" alt="" />
            </div>
            <div class="num">{{v.quantity}}</div>
            <div class="reduce" @click="addNum(v,i)">
              <img src="../../../assets/imgs/add.png" width="22px" height="22px" alt="" />
            </div>

          </div>
          <div @click="remove(v,i)" class=" remove"> 移除 </div>
        </div>
        <div class="selectBottom">
          <!-- <span style="margin-right: 36px">{{v.type==1 ? '零点': v.type ==2 ? '计时' :'套餐' }}</span> -->
          <!-- <span style="margin-right: 10px;text-decoration:line-through;color:#999">￥{{v.price}}/{{v.unitName}}
          </span> -->


        </div>
      </div>
    </div>
    <div class="selectFooter">
      <div class="footerTop">
        <div class="bz" style="padding: 5px 0">
          <span style="margin: 0 10px; color: #666">备注</span>
          <div class="" style="margin: 18px 10px 14px; color: #666">
            <el-radio-group v-model="radio" @change="changeradio">
              <el-radio :label="3">凉菜即起其他叫起</el-radio>
              <el-radio :label="6">全部叫起</el-radio>
              <el-radio :label="9">全部即起</el-radio>
              <el-radio :label="1">无</el-radio>
            </el-radio-group>
          </div>
          <div class="beizhu">
            <el-input v-model="remark" placeholder="除了凉菜都半小时后才开始做" @focus="beizhuinput" clearable style="width:100%">
            </el-input>

          </div>
        </div>
        <div class="allPrice">
          <div style="display:flex;justify-content: space-between;color: #666;margin-right:20px" >
            <div style="">
              合计

            </div>
            <div style=""> {{allquantity}}条 </div>
          </div>
          <div class="totalPrice">{{totalPrice.toFixed(2)}}</div>
        </div>
      </div>
      <div class="footerBottom">
        <div class="allcancle blueBtn" @click="allCanel" v-if='tableList.length>0'>全部取消</div>
        <div v-else></div>
        <div class="cvAndSD">
          <div class="blueBtn" @click="printOrder" v-if='tableList.length>0'> 打印</div>
          <!-- <div class="blueBtn" @click="testP"> 打印x</div> -->
          <div class="blueBtn" @click="more">复制多桌</div>
          <div class="jbBtn" v-if="!orderDishesFlag" @click="orderDishes" v-loading.fullscreen.lock="fullscreenLoading">
            送单</div>
        </div>
      </div>

    </div>

    <el-dialog title="复制多桌" :visible.sync="addFood" width="460px" center>

      <div class="addFoodMain">
        乘
        <el-input v-model="addFoodNum" type="number" style="width: 200px; margin: 0 15px" placeholder="请输入内容">
        </el-input>
        倍
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button style="
            background: #0099ff;
            color: #fff;
            width: 120px;
            height: 60px;
            border-radius: 38px;
          " @click="addFood = false">取 消</el-button>
        <el-button style="" type="primary" @click="addfoodCLick">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="选择技师" :visible.sync="JSvalueFlag" width="660px" center>

      <div class="textInput">
        <el-input v-model="description" style="width: 300px; margin: 0 15px" placeholder="输入拼音或汉字快速查找"
          @change="changemenu">
        </el-input>

      </div>
      <div class="menuitem">
        <div v-for="item in options" :key='item.id' class="menuItemName"
          :class="item.check ? 'menuItemNameCurrent' : ''" @click="changeDescription(item)">
          {{item.description}}
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button style="
            background: #0099ff;
            color: #fff;
            width: 120px;
            height: 60px;
            border-radius: 38px;
          " @click="JSvalueFlag = false">取 消</el-button>
        <el-button style="" type="primary" @click="updateMenu">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="改菜名" :visible.sync="nameflag" width="460px" center>

      <div class="addFoodMain">
        修改为
        <el-input v-model="updatedishesNames" style="width: 200px; margin: 0 15px" :placeholder="updatedishesName">
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button style="
            background: #0099ff;
            color: #fff;
            width: 120px;
            height: 60px;
            border-radius: 38px;
          " @click="nameflag = false">取 消</el-button>
        <el-button style="" type="primary" @click="updatedname">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="改价格" :visible.sync="quantityflag" width="460px" center>
      <div class="addFoodMain">
        修改为
        <el-input v-model="updatedishesNames" style="width: 200px; margin: 0 15px" :placeholder="updatedishesName"
          @change="updateNames"></el-input>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button style="
            background: #0099ff;
            color: #fff;
            width: 120px;
            height: 60px;
            border-radius: 38px;
          " @click="quantityflag = false">取 消</el-button>
        <el-button style="" type="primary" @click="updatedprice">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="提醒" :visible.sync="backflag" width="460px" center>

      <div class="addFoodMain">
        有未送的菜，是否返回
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button style="
            background: #0099ff;
            color: #fff;
            width: 120px;
            height: 60px;
            border-radius: 38px;
          " @click="backflag = false">取 消</el-button>
        <el-button style="" type="primary" @click="gobackCLick">确 定</el-button>
      </span>
    </el-dialog>
    <div v-if="remarkFlag" class="remarkDialog">

      <el-dialog title="单菜要求" :visible.sync="remarkFlag">

        <div class="menu">
          {{activeDish.dishesName}}
        </div>
        <div>
          <div class="menuRmarka" v-for="tr in remarkList" :key="tr.typeId">
            <div> {{tr.description}}</div>
            <div class="menuRmarkB">
              <div v-for="td in tr.foodMakeWayList" :key="td.id" :class="td.flag ? 'blueBtn' : ' '"
                @click="sureBTN(td,td.id,tr.typeId)">
                {{td.description}}
              </div>
            </div>

          </div>
        </div>
        <div class="menuRmarka">
          <div>其他</div>
          <div class="inputstyle">
            <input type="text" v-model="activeDish.remark" style="">
          </div>

        </div>

        <span slot="footer" class="dialog-footer">
          <el-button style="
            background: #0099ff;
            color: #fff;
            width: 120px;
            height: 60px;
            border-radius: 38px;
          " @click="remarkFlag = false">取 消</el-button>
          <el-button style="" type="primary" @click="gobacksureBTN">确 定</el-button>
        </span>

      </el-dialog>
    </div>

    <print v-show="false" :orderObj="orderObj" ref='printsss'> </print>
    <div v-show="printFlag" class="printsTable">

      <el-dialog title="预点菜" :visible.sync="printFlag" width="550px" center @close='closeprintFlag'>
        <div class="printSelect" v-if="checkPrinter == 1">

          <div class="printNameTxt">当前打印机：</div>
          <el-select v-model="printName" placeholder="请选择" class="PDateName" @change="changePDate">
            <el-option v-for="item in PDate" :key="item.value" :label="item.name" :value="item.name">
            </el-option>
          </el-select>

        </div>
        <div style="width:100%; display:flex; justify-content: center;overflow-y: auto;height:700px">
          <bill :orderObj="printobj" ref="bill" />
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button style="
            background: #0099ff;
            color: #fff;
            width: 120px;
            height: 60px;
            border-radius: 38px;
          " @click="printFlag = false">返 回</el-button>
          <el-button style="" type="primary" :loading="buttonLoading" @click="printtable">打 印</el-button>

        </span>
      </el-dialog>
    </div>

  </div>
</template>

<script>
  import print from "@/views/components/print.vue"
  import DateUtils from "@/utils/DateUtils";
  import bill from '@/views/dashboard/components/bill.vue'
  import getLodop from '@/utils/Lodopfuncs'

  export default {
    components: {
      print,
      bill
    },
    data() {
      return {
        activeDish: {},
        orderObj: [],
        requirementValue: '',
        requirement: 0,
        JSvalue: "",
        options: [],
        radio: 1,
        tableList: [],
        totalPrice: 0,
        printlist: [],
        name: '',
        remark: undefined,
        fullscreenLoading: false,
        addFood: false,
        addFoodNum: undefined,
        backflag: false,
        orderMenusMap: [],
        nameflag: false,
        quantityflag: false,
        //弹窗修改
        updatedishesName: '',
        updatedishesNames: '',
        //弹窗修改对应得数组下标
        updateArrrayNum: 0,
        printPosCode: "",
        printerPosCodeObj: [],
        obj: {},
        remarkList: [],
        remarkFlag: false,
        description: "",
        JSvalueFlag: false,
        selectObj: '',
        orderDishesFlag: false,
        buttonLoading: false,
        printobj: {},
        printName: null,
        PDate: [],
        printFlag: false,
        checkPrinter: null,
        allquantity: 0
      };
    },
    watch: {
      tableList(val) {

        this.$bus.$emit('tableList', val)
        if (val.length) {
          let number = 0
          val.forEach(res => {
            number += res.quantity
          })
          this.allquantity = number
        }
      }
    },
    created() {
      this.orderObj = JSON.parse(localStorage.getItem('openTaiUser'))
      // this.getlistByParam()
      this.orderDishesList()
      this.printPosCodes()
      if (this.$route.query.type == 1) {
        this.orderDishesFlag = true
      } else {
        this.orderDishesFlag = false

      }

    },
    beforeDestroy() {
      this.$bus.$off('printsuccess', );
    },
    methods: {
      //查询酒店打印主控点的设备编码
      testP() {		       
        this.CreatePrintPage();       
        LODOP.PREVIEW();		       
      },
      CreatePrintPage() {       
        LODOP=getLodop();         
        LODOP.PRINT_INIT("打印控件功能演示_Lodop功能_名片");       
        LODOP.ADD_PRINT_RECT(10,55,360,220,0,1);       
        LODOP.SET_PRINT_STYLE("FontSize",11);       
        LODOP.ADD_PRINT_TEXT(20,180,100,25,"郭德强");       
        LODOP.SET_PRINT_STYLEA(2,"FontName","隶书");       
        LODOP.SET_PRINT_STYLEA(2,"FontSize",15);		       
        LODOP.ADD_PRINT_TEXT(53,187,75,20,"科学家");       
        LODOP.ADD_PRINT_TEXT(100,131,272,20,"地址：中国北京社会科学院附近东大街西胡同");       
        LODOP.ADD_PRINT_TEXT(138,132,166,20,"电话：010-88811888");	       
      },
      printPosCodes() {
        console.log(this.api,'this.api')
        let code = localStorage.getItem('hotelCode')
        let url = this.api.printPosCode + '?hotelCode=' + code
        let methods = 'get'

        this.$axios({
          url,
          methods
        }).then(res => {
          this.printPosCode = res.data.data.printPosCode
          console.log(this.printPosCode,'设备编号------');

        })
      },
      //调用ipad 打印账单
      ipadprint(val) {
        let url = this.api.orderMq
        let methods = 'post'
        let obj = {
          data: JSON.stringify(val),
        }
        let data = {
          // toipcName: this.printPosCode,
          toipcName: this.printPosCode,
          status: 'Unprinted',
          type: 'menu',
          hotelCode: localStorage.getItem('hotelCode'),
          value: JSON.stringify(obj),
        }
        // this.$axios({
        //   url,
        //   methods,
        //   data
        // }).then(res => {
        //   console.log(res,'ipadPrint-----打印');
        //   this.routerPush()
        // })
      },
      beizhuinput() {
        this.radio = 1
      },
      //备注单选框
      changeradio(value) {
        console.log('changeradio', value);
        if (value == 3) {
          this.remark = '凉菜即起其他叫起'
        } else if (value == 6) {
          this.remark = '全部叫起'

        } else if (value == 9) {
          this.remark = '全部即起'

        } else if (value == 1) {
          this.remark = ''

        }
      },
      // 菜品数量加号
      addNum(v, i) {
        v.quantity++
        let total = 0;

        this.tableList.forEach(v => {
          total += v.quantity * v.price
          v.totalPrice = v.price * v.quantity * 1

          this.totalPrice = total
          console.log(v.total);
        })
        // v.menuNum++
        this.$bus.emit("addNum", v);
      },
      // 菜品数量减少
      reduceNum(v, i) {
        if (v.quantity <= 1) {
          this.$bus.emit("reduceNumorderList", v, true);

          this.tableList.splice(i, 1)

          let total = 0;
          if (v.update_date) {
            this.deleteTrues(v.id)
          }

          if (this.tableList.length) {

            this.tableList.forEach(v => {
              total += v.price * v.quantity
              v.total = v.price * v.quantity
              this.totalPrice = total

            })

          } else {
            this.totalPrice = 0
          }



          return
        }

        v.quantity--

        let total = 0;
        this.tableList.forEach(v => {
          total += v.price * v.quantity
          v.totalPrice = v.price * v.quantity
          console.log(v.total);

          this.totalPrice = total
        })

        this.$bus.emit("reduceNumorderList", v);

      },
      remove(v, i) {
        this.$bus.emit("removeList", v, true);

        this.tableList.splice(i, 1)

        let total = 0;
        if (v.update_date) {
          this.deleteTrues(v.id)
        }

        if (this.tableList.length) {

          this.tableList.forEach(v => {
            total += v.price * v.quantity
            v.total = v.price * v.quantity
            this.totalPrice = total

          })

        } else {
          this.totalPrice = 0
        }


      },
      // 删除菜
      deleteTrues(id) {
        let url = this.api.deleteTrue
        let methods = 'delete'
        let data = {
          id: id
        }
        this.$axios({
          url,
          methods,
          data
        }).then(res => {
          console.log(res);

        })
      },
      demo(arr1) {
        let arr = []
        arr1.map((res, i) => {
          res.printer.map((n, m) => {
            if (res.isKitchenPrint) {
              const obj = {
                dishesName: res.dishesName,
                quantity: res.quantity,
                remark: res.remark,
                unitName: res.unitName,
                printname: n.kitchenPrinterName,
                createDate: DateUtils.formatDate(new Date(),
                  "yyyy-MM-dd hh:mm:ss")
              }
              arr.push(obj)
            }
          })
        })
        return arr
      },
      demoa(arr1) {
        console.log('第一步', arr1);
        let cache = {}; //存储的是键是zhuanye 的值，值是zhuanye 在indeces中数组的下标
        let indices = []; //数组中每一个值是一个数组，数组中的每一个元素是原数组中相同zhuanye的下标
        arr1.map((item, index) => {
          let printname = item.printname;
          let _index = cache[printname];
          if (_index !== undefined) {
            indices[_index].push(index)
          } else {
            cache[printname] = indices.length
            indices.push([index])
          }
        })
        let result = []
        indices.map((item) => {
          // console.log(item);

          item.map((index) => {
            // console.log(index);

            result.push(arr1[index])

          })

        })

        return result
      },
      // 打印功能()
      async printlists() {
        console.log('打印菜单', this.tableList);
        let remark = this.remark
        const arr1 = await this.demo(this.tableList)
        const arr2 = await this.demoa(arr1)
        // console.log('remark', this.remark);
        // if (arr1.length == 0) {
        //   this.routerPush()
        // }

        setTimeout(() => {
          this.$bus.emit('printlist', arr2)
          console.log('打印机列表', arr2);
          this.$bus.emit('remark', remark)
        });

        this.$nextTick(() => {
          this.$refs.printsss.print()
        })

      },

      orderDishes() {
        if (this.tableList.length == 0) {
          this.$notify.error({
            title: '没有添加菜'
          });
          return;
        }

        this.fullscreenLoading = true;
        console.log('送单列表', this.tableList);
        let url = this.api.orderDishes
        let methods = 'post'
        let orderID = JSON.parse(localStorage.getItem('openTaiUser'))

        console.log(url,'url--------')
        let data = {
          id: this.$route.query.id,
          status: 'G',
          orderMenusMap: this.tableList,
          orderFrom: 'POS',
          remark: this.remark
        }
        // this.printlists()
        // return
        this.$axios({
          url,
          methods,
          data
        }).then(res => {
          console.log(res,'送单成功');
          if (res.data.status == 0) {
            this.$message({
              message: "送单成功",
              type: 'success'
            });
            this.fullscreenLoading = false;
            // const flag
            this.printlists()
            let arr = []
            const arr1 = this.demo(res.data.data.orderMenus)

            const arr2 = this.demoa(arr1)
            console.log('arr2', arr2);
            if (arr2.length) {
              this.demoaaa(arr2)
              
              // this.printOrder()
              setTimeout(() => {
              //   console.log('SelectedMenu.vue第650行:::router push', );
              //   this.printtable()
              //   this.printFlag = false
                // this.routerPush()
              }, 100);
            } else {
              this.routerPush()
            }


            this.obj = res.data.data;


          } else {
            this.$notify.error({
              title: res.data.message
            });
          }

        })
      },
      async demoaaa(arr) {
        console.log('开始', arr);
        let oldname = '',
          newname, arr1 = []
        arr1.push(arr[0])
        if (arr.length == 1) {
          this.name = arr[0].printname
          this.printlist = [...arr]
          console.log(this.name, this.printlist);
          this.$nextTick(() => {
            // const ab = this.todoPrint(arr[0].printname, arr)
            this.obj.orderMenusMap = arr1
            this.obj.orderMenus = arr1
            this.ipadprint(this.obj)
          })
          return
        }


        for (let i = 1; i < arr.length; i++) {
          oldname = arr[0].printname
          newname = arr[i].printname
          console.log('newname', oldname, newname);
          if (oldname == newname) {
            arr1.push(arr[i])
            if (i == arr.length - 1) {
              this.name = newname
              this.printlist = [...arr1]
              console.log('打印', this.printlist);
              this.$nextTick(() => {
                // const ab = this.todoPrint(oldname, arr1)
                this.obj.orderMenusMap = arr1
                this.obj.orderMenus = arr1
                this.ipadprint(this.obj)
              })
            }
          } else if (oldname != newname) {
            this.name = oldname
            this.printlist = [...arr1]
            console.log('打印', this.printlist);
            this.$nextTick(() => {
              // const ab = this.todoPrint(oldname, arr1)
              this.obj.orderMenusMap = arr1
              this.obj.orderMenus = arr1
              this.ipadprint(this.obj)
            })
            const a = arr.slice(i)
            setTimeout(() => {
              this.demoaaa(a)

            }, 500);
            break
          }
        }




      },
      //返回按钮
      gobackCLick() {
        if (this.tableList.length !== 0) {
          // this.fullscreenLoading = true;
          console.log('送单列表', this.tableList);
          let url = this.api.orderDishes
          let methods = 'post'
          let orderID = JSON.parse(localStorage.getItem('openTaiUser'))


          let data = {
            id: this.$route.query.id,
            status: 'L',
            orderMenusMap: this.tableList,
            orderFrom: 'POS',
            remark: this.remark
          }
          console.log(data);

          // return
          this.$axios({
            url,
            methods,
            data
          }).then(res => {
            console.log(res);
            if (res.data.status == 0) {
              this.backflag = false
              this.fullscreenLoading = false;
              this.routerPush()
            }
          })
        } else {

          this.routerPush()

        }
      },

      routerPush() {
        if (this.$route.query.type == 1) {
          this.$router.push({
            path: 'reserve/addreserve',
            query: {
              id: this.$route.query.id
            }
          })
        } else {
          this.$router.push({
            path: 'dashboard',
            query: {
              success: 1
            }
          })
        }


      },
      //修改 名字
      updatename(v, i) {
        if (v.is_can_update_name) {
          this.nameflag = true;
          this.updatedishesName = v.dishesName
          this.updatedishesNames = undefined
          this.updateArrrayNum = i
        }
      },
      //修改 名字 确定按钮
      updatedname() {

        if (this.updatedishesNames == null || this.updatedishesNames == undefined || this.updatedishesNames == 0) {
          console.log(1);
          this.nameflag = false
        } else {
          this.tableList[this.updateArrrayNum].dishesName = this.updatedishesNames

          this.nameflag = false
          this.$notify.success({
            title: '修改成功'
          })
        }


      },
      //修改价格弹窗
      updatequantity(v, i) {
        if (v.is_can_update_price) {
          this.quantityflag = true;
          console.log('修改价格', v);
          this.updatedishesName = v.price
          this.updatedishesNames = undefined
          this.updateArrrayNum = i
        }

      },
      updateNames(val) {
        const isPrice = /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/

        if (!isPrice.test(val)) {
          this.$message({
            message: '价格输入有误',
            type: 'warning'
          })
          this.updatedishesNames = null

        }
      },
      updatedprice() {
        const isPrice = /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/
        console.log(this.updatedishesNames);
        if (this.updatedishesNames == null || this.updatedishesNames == undefined) {

          this.quantityflag = false

          return
        } else if (isPrice.test(this.updatedishesNames)) {
          this.tableList[this.updateArrrayNum].price = this.updatedishesNames*1
          this.tableList[this.updateArrrayNum].totalPrice = this.updatedishesNames * this.tableList[this
            .updateArrrayNum].quantity

        }


        let num = 0

        this.tableList.map(e => {

          num = num + e.price * e.quantity

        })

        this.totalPrice = num
        this.$bus.$emit("totalPrice", num)
        this.quantityflag = false
        console.log(this.tableList);
        this.$notify.success({
          title: '修改成功'
        })

      },

      updateModel(v, i) {
        console.log(v, i);
        this.tableList[i].technician = {
          id: v.JSvalue
        }
      },

      //历史点餐数据
      orderDishesList() {
        let url = this.api.orderDishesList2 + '?orderRecordId=' + this.$route.query.id
        let methods = "get"
        let total = 0
        let number = 0
        this.$axios({
          url,
          methods
        }).then(res => {
          let arr = res.data.data.orderMenusMap
          if (arr.length) {
            arr.map(e => {
              if (e.remark) {
                this.$set(e, 'requirement', true)
              } else {
                this.$set(e, 'requirement', false)
              }
              this.tableList.push(e)
              this.$bus.$emit('orderDishesList', e)
              total += e.quantity * e.price
              // total = e.quantity * e.price
              number = number + e.quantity
            })
            this.$bus.$emit('number', number, total)
          }
          // console.log(total);
          this.totalPrice = total

        })

      },

      // 取消全部
      allCanel() {
        this.$confirm('请您确认是否取消全部?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          console.log('送单列表', this.tableList);
          let url = this.api.deleteDishesAll
          let methods = 'delete'
          let orderID = JSON.parse(localStorage.getItem('openTaiUser'))

          let data = {
            id: this.$route.query.id
          }

          this.$axios({
            url,
            methods,
            data
          }).then(res => {
            console.log(res);

            this.$message({
              type: 'success',
              message: '取消成功'
            });

            this.fullscreenLoading = false;
            this.tableList = []
            this.totalPrice = 0

            this.$bus.emit("allCanel", 0);

          })

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });

      },
      sureBTN(td, id, v) {
        console.log('SelectedMenu.vue第956行:::this.remarkList', this.remarkList);
        this.remarkList.map(e => {

          e.foodMakeWayList.map(re => {
            if (e.typeId == v && re.id == id) {

              re.flag = !re.flag
            }

          })
        })
      },
      requirementValueBlur(v) {
        // this.remarkFlag = true
        this.activeDish = v
        console.log(v);
        let id = JSON.parse(localStorage.getItem('openTaiUstatus'))
        console.log('openTaiUstatus', id);

        let url = this.api.listByOutletId + '?outletId=' + id.outletsId + '&foodDishId=' + v.dishesId
        let methods = 'get'
        this.$axios({
          url,
          methods
        }).then(res => {
          // this.orderObj = v

          res.data.data.map(e => {
            e.foodMakeWayList.map(re => {
              re.flag = false
            })
          })
          this.remarkList = res.data.data
          this.remarkFlag = true
          console.log('要求', this.remarkList);

        })

      },
      gobacksureBTN() {
        let text = ''
        // this.tableList.map(e => {
        //   if (e.dishesId == this.orderObj.dishesId) {
        //     this.remarkList.map(res => {
        //       res.foodMakeWayList.map(val => {
        //         if (val.flag) {
        //           text = text + val.description
        //         }
        //       })
        //     })
        //     console.log(e, text);
        //     if (e.remark) {
        //       e.remark = text + e.remark

        //     } else {
        //       e.remark = text
        //     }

        //   }
        // })
        this.remarkFlag = false
      },
      //技师列表
      getlistByParam() {
        let url = ''
        if (this.description) {
          url = this.api.getlistByParam + '?isOut=false&deleted=0&description=' + this.description
        } else {
          url = this.api.getlistByParam + '?isOut=false&deleted=0'
        }

        let methods = 'get'
        let arr = []
        this.$axios({
          url,
          methods
        }).then(res => {
          res.data.data.map(e => {
            e.check = false
          })
          this.options = res.data.data
          // console.log(arr);

          //  return arr

        })

      },
      //复制多桌
      more() {
        this.addFood = true
      },
      // 复制多桌确定按钮
      addfoodCLick() {
        if (!this.addFoodNum) return
        if (this.tableList.length == 0) {
          this.$notify.error({
            title: '没有添加菜'
          });
          return;
        }
        let num = 0
        let number = 0
        this.tableList.map(res => {
          res.quantity = this.addFoodNum * 1
          res.totalPrice = res.quantity * res.price
          num = num + res.quantity * res.price
          number = res.quantity + number
        })
        this.$bus.emit("status", this.tableList);
        this.$bus.emit("number", number, num);
        this.totalPrice = num
        this.addFood = false
      },
      // 技师弹窗
      openJSvalue(v) {
        this.JSvalueFlag = true
        this.selectObj = v
        this.description = ''

        this.getlistByParam()
        this.options.forEach(e => {
          if (e.description == v.JSvalue) {
            e.check = true
          }
        })

      },
      changemenu() {
        this.options = this.getlistByParam()
      },
      changeDescription(item) {
        this.options.map(res => {
          if (res.id == item.id) {
            res.check = !res.check
          } else {
            res.check = false
          }
        })
      },
      updateMenu() {
        let id = ''
        this.options.forEach(e => {
          if (e.check) {
            this.selectObj.JSvalue = e.description
            id = e.id
          }
        })
        this.tableList.map(res => {
          if (res.id == this.selectObj.id) {
            res.description = this.selectObj.JSvalue
            res.technician = {
              id
            }
          }
        })
        this.JSvalueFlag = false
      },
      //判断账单打印机 是否为本机内置
      getCurPosSite() {
        let url = this.api.getCurPosSite
        let methods = 'get'
        this.$axios({
          url,
          methods
        }).then(res => {
          console.log(res.data,'判断打印机');
          if (res.data.status == 0) {
            this.checkPrinter = res.data.data.checkPrinter
            console.log('是否为本机内置', this.checkPrinter);
          }
        })

      },
      //获取当前电脑得打印机
      GetPrinter() {
        //获取当前打印机

        LODOP = getLodop();

        var iCount = LODOP.GET_PRINTER_COUNT();

        var PData = [];

        for (var i = 0; i < iCount; i++) {
          PData.push({
            code: i,
            name: LODOP.GET_PRINTER_NAME(i)
          });
        }

        return PData;
      },
      closeprintFlag() {
        this.printFlag = false

      },
      printOrder() {
        this.getCurPosSite()
        this.printName = localStorage.getItem('printName')

        this.PDate = this.GetPrinter()

        this.printFlag = true

        this.printobj = JSON.parse(localStorage.getItem('openTaiUser'))
        this.printobj.total_price = this.totalPrice
        this.printobj.orderMenusMap = this.tableList;
        this.printobj.orderMenus = this.tableList;
        this.printobj.titles = '预点餐'
        console.log(this.printobj);


      },
      changePDate(v) {
        console.log('选择打印机', v);
        localStorage.setItem('printName', v)
        this.printName = v
        // this.$refs.bill.getPrint()
      },
      printtable() {
        const loading = this.$loading({
          lock: true,
          text: '打印中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
          loading.close();
        }, 2000);
        this.checkPrinter
        console.log('SelectedMenu.vue第1179行:::this.checkPrinter', this.checkPrinter);
        if (this.checkPrinter == 2) {
          this.tableinput()
          this.$message({
            message: "已成功向总控打印机推送任务",
            type: "success"
          })
        } else {
          // 本机打印
          if (!localStorage.getItem('printName')) {
            this.PDate = this.GetPrinter()
            this.$message({
              message: '请先选择打印机再打印',
              type: 'warning'
            });
          } else {

            console.log(this.printobj, this.printName);
            this.$bus.$emit('printName', this.printName)

            this.$refs.bill.getPrint()
            this.$message({
              message: "已成功向本地打印机推送任务",
              type: "success"
            })

            // this.printFlag = false

            // localStorage.removeItem('openTaiUstatus')
            // if (this.routeStatus == 0) {
            //   this.refund()
            // }
          }
        }
      },
      tableinput() {
        let url = this.api.orderMq
        let methods = 'post'
        let obj = {
          data: JSON.stringify(this.printobj),
        }

        let data = {
          toipcName: this.printPosCode,
          status: 'Unprinted',
          hotelCode: localStorage.getItem('hotelCode'),
          type: 'order',
          value: JSON.stringify(obj),
        }
        this.$axios({
          url,
          methods,
          data
        }).then(res => {
          // console.log(res);
          this.printFlag = false
        })
      }


    },
    mounted() {
      //通过on监听事件，回调方法获取数据      
      //获取中间点菜数组
      this.$bus.on("bload", v => {
        let total = 0
        let arr = this.tableList
        let obj = {
          dishesId: v.id,
          type: v.type,
          quantity: v.quantity ? v.quantity : 1,
          totalPrice: v.is_price_show1 ? v.unit_price1 : v.unit_price2,
          price: v.is_price_show1 ? v.unit_price1 : v.unit_price2,
          remark: null,
          technician: null,
          orderRecordId: v.orderRecordId,
          dishesName: v.food_name,
          foodTypeId: v.food_type_id,
          status: 'L',
          unitName: v.unitName,
          dishesCode: v.code,
          printer: v.printer,
          is_can_update_name: v.is_can_update_name,
          is_can_update_price: v.is_can_update_price,
          isKitchenPrint: v.isKitchenPrint,
          orderRecordId: this.$route.query.id,
          requirement: false
        }



        if (this.tableList.length > 0) {

          try {
            this.tableList.forEach((vv, n) => {

              if (vv.dishesId == obj.dishesId) {

                let number = vv.quantity
                let numss = (number + 1) * obj.price * 1

                this.$set(vv, "quantity", vv.quantity + obj.quantity * 1)
                this.$set(vv, "totalPrice", numss)

                throw new Error('LoopInterrupt');
              } else if (n == this.tableList.length - 1) {
                this.tableList.push(obj)
              }
            })
          } catch (e) {

          }

        } else {
          this.tableList.push(obj)
        }

        obj.totalPrice = obj.quantity * obj.price * 1


        this.totalPrice = this.totalPrice + obj.totalPrice



      });

      this.$bus.$on("printsuccess", val => {
        if (val) {
          this.routerPush()
        }
      })
      this.$bus.$on('goback', val => {
        if (this.tableList.length) {
          this.backflag = true
        } else {
          this.routerPush()

        }

      })
    },
  };
</script>

<style scoped lang="scss">
  .selectmenu {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;

    .selectTitle {
      width: 100%;
      height: 50px;
      line-height: 50px;
      text-align: center;
      color: #0099ff;
      font-size: 20px;
      border-bottom: 1px solid #eaeaea;
    }

    .selectMain {
      border-bottom: 1px solid #eaeaea;
      // height: 630px;
      flex: 1;
      width: 100%;
      overflow: auto;
      position: relative;

      .selectItem {
        width: 100%;
        height: 40px;
        border-bottom: 1px solid #eaeaea;

        .selectTop {
          display: grid;
          grid-template-columns: 70px 1fr 90px 130px 180px 100px 40px;
          align-items: center;
          font-size: 16px;
          padding: 2px 10px;

          /deep/ .el-input {
            height: 36px;
          }

          /deep/ .el-input__inner {
            height: 36px;
          }

          .selectNum {

            display: flex;
            justify-content: center;
            align-items: center;

            .num {
              margin: 0 10px;
              color: #fe852f;
            }

            .reduce,
            .add {
              cursor: pointer;
            }
          }

          .remove {
            width: 40px;
            height: 20px;
            line-height: 20px;
            font-size: 8px;
            background: #0099ff;
            border-radius: 8px;
            text-align: center;
            color: #fff;
          }
        }


      }
    }

    .selectFooter {
      flex: 0 0 200px;
      display: flex;
      flex-direction: column;

      .footerTop {
        display: flex;
        border-bottom: 1px solid #eaeaea;

        .bz {
          flex: 1;
        }

        .beizhu {
          margin: 0 10px;
          background: #eeeeee;
          color: #666666;
          height: 56px;
          line-height: 56px;
          text-indent: 10px;
          border-radius: 6px;
        }

        .allPrice {
          flex: 0 0 215px;
          padding: 20px 7px;
          border-left: 1px solid #eaeaea;

          .totalPrice {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 100%;
            font-size: 36px;
            color: #fe8d30;
          }
        }
      }

      .footerBottom {
        flex: 0 0 50px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 10px;
        margin-top: 5px;

        .blueBtn {
          width: 140px;
          height: 40px;
          background: #0099ff;
          color: #fff;
          font-size: 18px;
          line-height: 40px;
          text-align: center;
          border-radius: 38px;
          margin-right: 10px;
          cursor: pointer;
        }

        .jbBtn {
          width: 100px;
          cursor: pointer;
          height: 40px;
          background: linear-gradient(225deg, #ffbe34 0%, #fe812f 100%);
          box-shadow: 0px 2px 10px 0px rgba(254, 137, 47, 0.3);
          border-radius: 38px;
          color: #fff;
          font-size: 18px;
          line-height: 40px;
          text-align: center;
        }

        .cvAndSD {
          display: flex;
        }
      }
    }
  }

  .print {
    position: fixed;
    z-index: 9;
    opacity: 0;
    top: 0;
    left: 200px;
  }

  .addFoodMain {
    height: 66px;
    display: flex;
    width: 100%;
    justify-content: center;

    align-items: center;
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #666666;

    /deep/.el-input__inner {
      font-size: 24px;
      border: none;
      width: 200px !important;
      padding: 0;
      background: #eee;
      text-align: center;
    }
  }

  .hiddenTips {
    width: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    .tips {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: #bbe4ff;
      font-size: 28px;

      span {
        margin-top: 40px;
      }
    }
  }

  .menuRmarka {
    margin: 20px;
  }

  .menuRmarkB {
    display: flex;
    flex-wrap: wrap;
  }

  .textInput {
    /deep/ .el-input__inner {
      width: 440px !important;
      border: 1px solid #eee;

    }
  }

  .menuitem {
    display: flex;
    flex-wrap: wrap;
    align-items: center;


  }

  .menuItemName {
    width: 140px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-size: 16px;
    background: #eeeeee;
    border-radius: 10px;
    color: #666667;
    cursor: pointer;
    margin: 10px;

  }

  .menuItemNameCurrent {
    background: #0099ff;
    color: #fff;
  }
</style>

<style lang="scss" scoped>
  /deep/.el-input__inner {
    border: none;
    width: 80px;
    padding: 0;
  }

  .beizhu {
    /deep/ .el-input__inner {
      width: 90%;
      // padding: 0;
    }
  }

  /deep/.el-button--primary {
    border-radius: 38px;
    width: 180px;
    background: -webkit-gradient(linear,
        0 0,
        0 100%,
        from(#ffbe34),
        to(#fe812f)) !important;
    border: none;
  }

  /deep/.el-button {
    font-size: 18px;
    height: 60px;
    font-weight: 400;
  }

  /deep/.el-dialog__footer {
    margin-bottom: 30px;
  }

  /deep/.el-dialog {
    // height: 612px;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 10px;
  }

  /deep/.el-dialog__header {
    margin-top: 50px;
    background: #fff;
  }

  /deep/.el-dialog__title {
    color: #0099ff;
    font-size: 28px;
  }

  .remarkDialog {
    /deep/ .el-dialog {
      margin-top: 3vh !important;
      margin-bottom: 6vh !important;
      overflow: auto;
    }

    font-size: 18px;

    /deep/ .el-dialog__body {
      width: 100%;
      padding-top: 0;

      .menu {
        text-align: center;
      }

      .menuRmarka {
        margin: 20px 30px;
        font-size: 24px;
      }

      .menuRmarkB {
        margin: 20px 0;

        div {
          padding: 10px 30px;
          border-radius: 6px;
          background: #eeeeee;
          margin: 0 20px;
        }

        .blueBtn {
          background: #0099ff;
          color: #fff;

          text-align: center;

          cursor: pointer;
        }
      }

      .inputstyle {
        border: 1px solid #0099ff;
        background: #77c3f5;
        width: 500px;
        height: 60px;
        border-radius: 4px;
        margin-top: 20px;

        input {
          width: 498px;
          height: 100%;
          border: 1px solid #0099ff;
          background: #77c3f5;
          color: #eee;
          outline: none;
        }
      }
    }
  }

  .printSelect {
    display: flex;
    align-items: center;
    justify-content: center;




    .PDateName {
      border: 1px solid #666;
      width: 200px;
      height: 30px;
      margin-left: 20px;

      /deep/.el-input__inner {
        // border: none;
        width: 200px !important;
        height: 30px;
        line-height: 30px;
        padding: 0 10px;
        // line-height: 0 !important;
        background: transparent;

      }

      /deep/ .el-input--suffix {
        margin-bottom: 0;
      }
    }
  }

  .printsTable {

    /deep/.el-dialog {
      margin-top: 3vh !important;
      margin-bottom: 6vh !important;
      overflow: auto;
    }

    /deep/ .el-dialog__header {
      margin-top: 10px;
      
    }
  }
</style>